var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPatient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M13.323 12.907a4.687 4.687 0 1 1 0 9.375 4.687 4.687 0 0 1 0-9.375zm.912 1.927h-1.5v2.01h-2.01v1.5h2.01v2.011h1.5v-2.01h2.01v-1.5h-2.01v-2.01zm-10.737 2a10.31 10.31 0 0 0 2.75.516l-.053 1a11.352 11.352 0 0 1-3.016-.569zM.002 14.218L1 14.25c-.001.732.26 1.273.755 1.64.144.106.294.21.447.308l-.54.842a8.951 8.951 0 0 1-.502-.347C.413 16.14 0 15.298 0 14.323l.002-.105zm1.464-4.505l.808.589a6.476 6.476 0 0 0-1.095 2.482l-.978-.211a7.486 7.486 0 0 1 1.265-2.86zm11.044.007c.476.66.836 1.4 1.084 2.201-.091-.005-.18-.014-.271-.014-.261 0-.517.024-.77.058a6.467 6.467 0 0 0-.854-1.659zm-2.193-3.185l.877.482c-.164.297-.36.583-.588.857a6.457 6.457 0 0 1 .78.605l-.668.744a8.39 8.39 0 0 0-.224-.193c-.192-.158-.4-.296-.61-.436l-.82-.563.428-.423c.34-.334.618-.695.825-1.073zm-6.631.028c.21.383.489.732.827 1.037l.489.44-1.063.676c-.079.05-.158.097-.232.152-.147.111-.29.226-.425.344l-.656-.755c.154-.134.315-.263.482-.389.09-.068.185-.128.282-.188a4.823 4.823 0 0 1-.582-.837l.878-.48zM2.678 2.655l.908.419a3.99 3.99 0 0 0-.31 2.307l-.987.167a4.878 4.878 0 0 1-.068-.811c0-.715.158-1.435.457-2.082zm8.601-.048c.328.674.502 1.414.502 2.142 0 .247-.019.496-.06.747l-.987-.16c.031-.196.047-.393.047-.587 0-.576-.139-1.166-.4-1.703l.898-.44zM6.184.019l.167.987a3.79 3.79 0 0 0-1.982.967l-.08.078-.713-.701.108-.106a4.794 4.794 0 0 1 2.5-1.225zm1.57-.02c.89.13 1.7.497 2.345 1.058.096.083.188.17.277.262l-.716.698a3.812 3.812 0 0 0-.217-.206A3.565 3.565 0 0 0 7.61.99L7.754 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6-3h28v28H-6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPatient);
export default __webpack_public_path__ + "static/media/add-patient.03aec7b5b99f785701e73f309e63cee8.svg";
export { ForwardRef as ReactComponent };